import React from 'react';
import RequireFeatureComponent from './require-feature.component';
import { HiddenFeature } from './hidden-feature.component';

export function requireFeature(Component, requiredFeatures, requiredForIntegrationTypes = null) {
  class RequirementFunction extends React.Component {
    render() {
      return (
        <RequireFeatureComponent
          requiredForIntegrationTypes={requiredForIntegrationTypes}
          requiredFeatures={requiredFeatures}
          hideDisplay={<HiddenFeature/>}
          {...this.props}>
          <Component {...this.props}/>
        </RequireFeatureComponent>
      );
    }
  }
  return RequirementFunction;
}



// WEBPACK FOOTER //
// src/features/require-feature.js